import EPage from '@/enums/EPages';
import EBasicActions from '@/enums/EBasicActions';
import { getMasterFranchiseConfigurations } from '@/services/MasterFranchiseConfigurationService';
import hasStoredAccess from '@/shared/helpers/hasStoredAccess';

export const DEFAULT_URL = '/home';

// One entry per master_franchise_configurations 'default_login_page' option (kept in sync with
// the options offered in MasterFranchiseDetails). Add new destinations here as they show up,
// with an optional `hasAccess` gate, instead of branching in getDefaultLoginUrl.
const DEFAULT_LOGIN_PAGE_ROUTES: Record<string, { path: string, hasAccess?: () => boolean }> = {
  'home': {
    path: '/home',
  },
  'establishments/dashboard': {
    path: '/establishments/dashboard',
    hasAccess: () => hasStoredAccess(EPage.Establishments, EBasicActions.Find),
  },
};

/**
 * Resolves the landing page for a signed-in staff from the master_franchise
 * 'default_login_page' config, falling back to DEFAULT_URL when unset, unknown,
 * not accessible or the request fails.
 *
 * Shared by the login submit and the `/` index route.
 */
const getDefaultLoginUrl = async (): Promise<string> => {
  try {
    // masterFranchiseId 1: mirrors the same single-master-franchise assumption
    // already used in Topbar.tsx, staff has no masterFranchiseId on the client yet
    const masterFranchiseConfigs = await getMasterFranchiseConfigurations({ masterFranchiseId: 1 });
    const defaultLoginPage = masterFranchiseConfigs
      .find(config => config.key === 'default_login_page')?.value;

    const route = defaultLoginPage ? DEFAULT_LOGIN_PAGE_ROUTES[defaultLoginPage] : undefined;
    if (!route) return DEFAULT_URL;

    const hasAccess = route.hasAccess ? route.hasAccess() : true;
    return hasAccess ? route.path : DEFAULT_URL;
  } catch (err) {
    console.error(err);
    return DEFAULT_URL;
  }
};

export default getDefaultLoginUrl;
